/**
 * DOM lookups for the product card broken-image diagnostic badge (ISS-04-093)
 */

import { FormBase } from "../../../util/form-base-form";

class ProductCardImageErrorForm extends FormBase {
    public isDiagnosable(wrapper: Element): boolean {
        return this.closest(wrapper, '[data-can-diagnose-images="1"]', HTMLElement) !== null;
    }

    public getBadgesContainer(wrapper: Element): HTMLElement | null {
        return this.queryElement(wrapper, ".product-image-badges", HTMLElement);
    }

    /**
     * Wrappers whose <img> already failed and was removed by the card's own
     * inline onerror before this module got a chance to observe the "error"
     * event live (a real race on fast-failing, above-the-fold images — the
     * inline handler is attached at HTML-parse time, this module only runs
     * once deferred JS executes). The failed src is recorded on the wrapper
     * via data-image-error-src so it can still be diagnosed after the fact.
     */
    public queryFailedImageWrappers(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, ".product-card__image-wrapper[data-image-error-src]", HTMLElement);
    }
}

const productCardImageErrorForm = new ProductCardImageErrorForm();

export { productCardImageErrorForm };
